import type { ReactNode } from "react";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";

/** The authored title belongs to the card and scrolls with its content. */
export function SlideTitle({ children }: { children?: ReactNode }) {
  return (
    <Text
      accessibilityRole="header"
      className="text-left text-2xl font-bold text-foreground"
      selectable
    >
      {children}
    </Text>
  );
}
